/* eslint-disable */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SidebarItem from './SidebarItem';
import OrderWindow from './OrderWindow';
import { TranslatedCopy } from '../intl/TranslatedCopy';

class Sidebar extends Component {
  // TODO: This should not need to be here. Parent component is causing a CRAP ton of re-renders
  shouldComponentUpdate(nextProps) {
    return nextProps !== this.props;
  }

  buildItems() {
    const { orderWindows } = this.props;
    const current = orderWindows.filter(window => window.currentlyActive());
    const upcoming = orderWindows.filter(window => window.isUpcoming());
    const result = [];

    // Build Current
    current.forEach(window => result.push(this.buildItem(window, true)));

    // Build the rest of the upcoming
    if (upcoming.length) {
      result.push(this.buildCategory('upNext'));
      upcoming.forEach((window, index) => result.push(this.buildItem(window, current.length === 0 && index === 0)));
    }

    return result;
  }

  buildItem(item, showClosureNote = false) {
    const { selectedWindow, onSidebarItemClick } = this.props;

    return (
      <SidebarItem
        key={item.name}
        item={item}
        isSelected={item === selectedWindow}
        showClosureNote={showClosureNote}
        onClick={onSidebarItemClick}
      />
    );
  }

  buildCategory(key) {
    return (
      <div key={key} className='orderDeadlines__categoryTitle body-4'>
        <TranslatedCopy id={`orderDeadlines.${key}`} />
      </div>
    );
  }

  buildNoResults() {
    return (
      <Fragment>
        {this.buildCategory('upcoming')}
        <div className='headline-5'>
          <TranslatedCopy id='orderDeadlines.noResult' />
        </div>
      </Fragment>
    );
  }

  render() {
    const items = this.buildItems();

    return <div className='orderDeadlines__sidebar'>{items.length > 0 ? items : this.buildNoResults()}</div>;
  }
}

Sidebar.propTypes = {
  orderWindows: PropTypes.arrayOf(PropTypes.instanceOf(OrderWindow)).isRequired,
  selectedWindow: PropTypes.instanceOf(OrderWindow),
  onSidebarItemClick: PropTypes.func.isRequired
};

export default Sidebar;
